import { ExternalLink } from "@/components/ExternalLink";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { CheckIcon } from "@radix-ui/react-icons";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import { createEnum } from "@/lib/utils/createEnum";
import {
  buildSharedPortfolioColumns,
  withPortfolioActions,
} from "@/lib/portfolios/tableColumns";

export type C5Portfolio = {
  id: number;
  client: string;
  vehicle: string | null;

  account_name: string;
  short_account_name: string | null;

  name: string;
  currency: string;
  reporting_currency: string;

  bank_name: string | null;
  account_type: string;

  investment_type: string | null;
  contract_name: string | null;

  code: string;

  has_pdf_bank_page: boolean | null;
  display_performance_report: boolean | null;
  bank_connection: boolean | null;

  collateral: boolean | null;

  has_transactions?: boolean;

  vehicle_index: number | null;
};
export const c5PortfolioFields = createEnum<C5Portfolio>();

export const columnVisibilityInit: Record<string, boolean> = {
};

const boolCell =
  () =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ getValue }: any) =>
    Boolean(getValue()) && (
      <div className="flex justify-center">
        <CheckIcon />
      </div>
    );

export const porfolios_columns: ColumnDef<C5Portfolio>[] = withPortfolioActions(
  buildSharedPortfolioColumns<C5Portfolio, unknown>({
    booleanCell: boolCell(),
    fields: {
      id: c5PortfolioFields.id,
      client: c5PortfolioFields.client,
      vehicle: c5PortfolioFields.vehicle,
      reporting_currency: c5PortfolioFields.reporting_currency,
      account_name: c5PortfolioFields.account_name,
      name: c5PortfolioFields.name,
      account_type: c5PortfolioFields.account_type,
      currency: c5PortfolioFields.currency,
      code: c5PortfolioFields.code,
      bank_name: c5PortfolioFields.bank_name,
      bank_connection: c5PortfolioFields.bank_connection,
    },
  }),
  [
    {
      id: "actions",
      cell: ({ row }) => {
        const hasTransactions = row.original.has_transactions;

        return (
          <div className="flex gap-3 justify-end">
            <ExternalLink
              href={toWorkspacePath(
                `/admin/${Clients.C5}/${Tables.C5_TRANSACTIONS}`,
              )}
              queryParams={{
                c5_portfolios_id_equal: row.getValue(c5PortfolioFields.id),
              }}
              className={`text-xs ${
                !hasTransactions ? "invisible pointer-events-none" : ""
              }`}
              underline="hover"
            >
              Transactions
            </ExternalLink>
            <Link
              href={`${window.location.pathname}/${row.getValue(c5PortfolioFields.id)}`}
              className="text-xs"
              underline="hover"
            >
              {i18n.t("actions.edit")}
            </Link>
          </div>
        );
      },
    },
  ],
);
